import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import createPersistedState from 'vuex-persistedstate';

import common from './modules/common';
import editor from './modules/editor';
import loader from './modules/loader';
import user from './modules/user';
import tokens from './modules/tokens';
import ork from './modules/ork';
import listsForEditor from './modules/listsForEditor';
import status from './modules/status'
import spk from './modules/spk'
import career from './modules/career'
import hints from './modules/hints'
import demandedPK from './modules/demandedPK'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = createPersistedState({
    paths: ['tokens', 'ork.curOrkId'],
    key: ['ork.nark']
});

export default new Vuex.Store({
    modules: {
        common,
        editor,
        loader,
        user,
        tokens,
        ork,
        listsForEditor,
        status,
        spk,
        career,
        hints,
        demandedPK
    },
    strict: debug,
    plugins: [
        state
    ].filter(Boolean)
});
